module.exports = __webpack_public_path__ + "static/media/genomics.2e49b540.jpeg";